import { React, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { Container, Row, Col, Navbar, Nav, NavDropdown, Button, Dropdown } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimes } from '@fortawesome/free-solid-svg-icons'
import { faArrowRight } from '@fortawesome/free-solid-svg-icons'
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons'
import ToggleSwitch from "../../Modals/ToggleSwitch";
import ConnectModal from '../../Modals/ConnectModal';
import darkLogo from '../../assets/images/logo-dark.png';
import lightLogo from '../../assets/images/logo-light.png';
import settingsIcon from '../../assets/images/icon-settings.svg';
import iconWallet from '../../assets/images/icon-wallet.png';
import iconMoon from '../../assets/images/icon-dark.svg';
import iconSun from '../../assets/images/icon-sun.svg';
import flagIcon from '../../assets/images/flag-us.png';
import flagFR from '../../assets/images/flag-france.png';
import flagID from '../../assets/images/flag-indonesia.png';
import flagJP from '../../assets/images/flag-japan.png';
import flagKR from '../../assets/images/flag-korea.png';
import flagRU from '../../assets/images/flag-russia.png';
import flagSP from '../../assets/images/flag-spain.png';
import flagVT from '../../assets/images/flag-vitenamese.png';
import flagCH from '../../assets/images/flag-chinese.png';
import $ from 'jquery';

import './Header.css';



function Header(props) {
	const history = useHistory();
	const pathname = history.location.pathname;
	const [isActive, setActive] = useState(false);
	const toggleClass = () => {
		setActive(!isActive);
	};
	const [isLight, setLight] = useState(false);

	return (
		<div className="header">
			<Container fluid>
				<Row className="align-items-center">
					<Col xs={6}>
						<div className="d-flex navigation-holder">
							<strong className="logo">
								<Link className="d-inline-block align-top" to="/">
									<img src={darkLogo} alt="Logo" className="logo img-fluid dark-logo" />
									<img src={lightLogo} alt="Logo" className="logo img-fluid light-logo" />
								</Link>
							</strong>
							<Navbar expand="xl" className="pos-stat">
								<Navbar.Toggle aria-controls="basic-navbar-nav" />
								<Navbar.Collapse id="basic-navbar-nav">
									<ul className="navbar-nav ml-auto">
										<li className={`nav-item ${pathname==='/' ? 'active' : ''}`}><Link className="nav-link" to="/">Swap </Link></li>
										<li className="nav-item">
											<NavDropdown title="Earn" id="basic-nav-dropdown">
												<Link className="d-block dropdown-item" to="/farms">Farms</Link>
												<Link className="d-block dropdown-item" to="/pools">Pools</Link>
											</NavDropdown>
										</li>
										<li className={"nav-item"}><Link className="nav-link" to="/info">INFO </Link></li>
										<li className={"nav-item"}><Link className="nav-link" to="/ifo">IFO</Link></li>
										<li className={"nav-item"}><Link className="nav-link" to="/voting">Voting </Link></li>
										{/* <li className={`nav-item ${pathname==='/pools' ? 'active' : ''}`}><Link className="nav-link" to="/pools">Pool</Link></li> */}
										{/* <li className={`nav-item ${pathname==='/rewards' ? 'active' : ''}`}><Link className="nav-link" to="/rewards">Rewards</Link></li> */}
										{/* <li className={`nav-item has-dropdown ${pathname==='/charts' ? 'active' : ''}`}><Link className="nav-link" to="/charts">Charts</Link></li> */}
										{/* <li className="nav-item dots-dropdown">
											<NavDropdown title="..." id="basic-nav-dropdown">
												<Link className="d-block dropdown-item" to="/info">INFO</Link>
												<Link className="d-block dropdown-item" to="/ifo">IFO</Link>
												<Link className="d-block dropdown-item" to="/voting">Voting</Link>
											</NavDropdown>
										</li> */}
									</ul>
									<ul className="navbar-nav d-block d-xl-none">
										<li className="nav-item"><Link className="nav-link" to="/rewards">Cardano Network</Link></li>
										<li className="nav-item"><Link className="nav-link" to="/rewards">Bridge Assets</Link></li>
										<li className="nav-item"><Link className="nav-link" to="/rewards">ADASWAP</Link></li>
									</ul>
								</Navbar.Collapse>
							</Navbar>
						</div>
					</Col>
					<Col xs={6}>
						<div className="header-btns-holder">
							<button className="btn-cardano transition d-none d-xl-block">Cardano Network</button>
							<button className="btn-bridge has-dropdown transition d-none d-xl-block">Bridge Assets</button>
							<button className="btn-adaswap transition text-uppercase d-none d-xl-block">ADASWAP</button>
							<ConnectModal />
							<Dropdown className="settings-dropdown position-relative" style={{inset: "inset: 0px 0px auto auto"}}>
								<Dropdown.Toggle id="dropdown-basic">
									<img className="img-fluid" src={settingsIcon} alt="" />
								</Dropdown.Toggle>
								<Dropdown.Menu>
									<h2 className="drop-down-heading position-relative mb-3">
										Global Settings
										<Dropdown.Toggle id="dropdown-basic">
											<FontAwesomeIcon className="icon-close" icon={faTimes} />
										</Dropdown.Toggle>
										{/* <FontAwesomeIcon onClick={() => modelCloseClick()} className="icon-close" icon={faTimes} />Global Settings */}
									</h2>
									<div className="d-flex dropdown-cols justify-content-between">
										<div className="mode-holder dropdown-col">
											<div className="d-flex justify-content-between mb-4">
												<span className="mode-icon">
													<img className="img-fluid dark-icon" src={iconMoon} alt="" />
													<img className="img-fluid light-icon" src={iconSun} alt="" />
												</span>
												<span className="mode-switch" >
													<ToggleSwitch toggleMode={true}/>
												</span>
											</div>
											<strong className="mode-dark-name mode-name  mb-2">Dark Mode</strong>
											<strong className="mode-light-name mode-name mb-2">Light Mode</strong>
											<span className="mode-status d-block">Active</span>
										</div>
										<div className="language-holder dropdown-col">
											<div className="d-flex justify-content-between mb-4">
												<span className="flag-icon">
													<img className="img-fluid" src={flagIcon} alt="" />
												</span>
												<span className="arrow-icon rounded-circle d-flex justify-content-center align-items-center cur-poi" onClick={toggleClass}>
													<FontAwesomeIcon icon={faArrowRight} />
												</span>
											</div>
											<strong className="mode-name d-block mb-2">English</strong>
											<span className="mode-status d-block">Choose Language</span>
										</div>
									</div>
									<div className="languages-holder" className={isActive ? 'languages-holder show': 'languages-holder'}>
										<Row>
											<Col xs={12}>
												<h2 className="block-heading text-center position-relative mb-3"><FontAwesomeIcon className="icon-left-arrow cur-poi" icon={faArrowLeft} onClick={toggleClass} />Select Language</h2>
											</Col>
											<Col xs={6}>
												<div className="language-item d-flex align-items-center cur-poi">
													<span className="flag-icon me-2">
														<img className="img-fluid" src={flagIcon} alt="" />
													</span>
													<span className="language-name">English</span>
												</div>
											</Col>
											<Col xs={6}>
												<div className="language-item d-flex align-items-center cur-poi">
													<span className="flag-icon me-2">
														<img className="img-fluid" src={flagKR} alt="" />
													</span>
													<span className="language-name">Korean</span>
												</div>
											</Col>
											<Col xs={6}>
												<div className="language-item d-flex align-items-center cur-poi">
													<span className="flag-icon me-2">
														<img className="img-fluid" src={flagCH} alt="" />
													</span>
													<span className="language-name">Chinese</span>
												</div>
											</Col>
											<Col xs={6}>
												<div className="language-item d-flex align-items-center cur-poi">
													<span className="flag-icon me-2">
														<img className="img-fluid" src={flagRU} alt="" />
													</span>
													<span className="language-name">Russian</span>
												</div>
											</Col>
											<Col xs={6}>
												<div className="language-item d-flex align-items-center cur-poi">
													<span className="flag-icon me-2">
														<img className="img-fluid" src={flagFR} alt="" />
													</span>
													<span className="language-name">French</span>
												</div>
											</Col>
											<Col xs={6}>
												<div className="language-item d-flex align-items-center cur-poi">
													<span className="flag-icon me-2">
														<img className="img-fluid" src={flagSP} alt="" />
													</span>
													<span className="language-name">Spanish</span>
												</div>
											</Col>
											<Col xs={6}>
												<div className="language-item d-flex align-items-center cur-poi">
													<span className="flag-icon me-2">
														<img className="img-fluid" src={flagID} alt="" />
													</span>
													<span className="language-name">Indonesian</span>
												</div>
											</Col>
											<Col xs={6}>
												<div className="language-item d-flex align-items-center cur-poi">
													<span className="flag-icon me-2">
														<img className="img-fluid" src={flagVT} alt="" />
													</span>
													<span className="language-name">Vitenamese</span>
												</div>
											</Col>
											<Col xs={6}>
												<div className="language-item d-flex align-items-center cur-poi">
													<span className="flag-icon me-2">
														<img className="img-fluid" src={flagJP} alt="" />
													</span>
													<span className="language-name">Japenese</span>
												</div>
											</Col>
										</Row>
									</div>
								</Dropdown.Menu>
							</Dropdown>
						</div>
					</Col>
				</Row>
			</Container>
		</div>
		);
}
export default Header;